import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";

import { clearCurrentVehicleAssignmentDetail } from "Redux/Dashboard/slice";

import IssuesCalendarDetail from "./IssuesCalendarDetail";
import IssuesCalendar from "./IssuesCalendar";
import { IssuesChartsByStatus } from "../IssuesChartsByStatus/IssuesChartsByStatus";
import { useAppDispatch } from "Redux/store";
import { getDashboardIssuesStatus } from "Redux/Dashboard/reducer";

const IssuesCalendarDashboard = () => {
  const [detailVehicleAssignment, setDetailVehicleAssignment] =
    useState<boolean>(false);
  const [issueId, setIssueId] = useState<string | null>(null);

  const openDetailVehicleAssignment = () => setDetailVehicleAssignment(true);
  const closeDetailVehicleAssignment = () => {
    setDetailVehicleAssignment(false);
    clearCurrentVehicleAssignmentDetail();
  };
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getDashboardIssuesStatus());
  }, [dispatch]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={8}>
        <IssuesCalendar
          issueId={issueId}
          setIssueId={setIssueId}
          closeDetailAssigment={closeDetailVehicleAssignment}
          openDetailAssigment={openDetailVehicleAssignment}
        />
      </Grid>
      <Grid item xs={4}>
        {detailVehicleAssignment ? (
          <IssuesCalendarDetail
            setIssueId={setIssueId}
            closeModal={closeDetailVehicleAssignment}
          />
        ) : (
          <IssuesChartsByStatus />
        )}
      </Grid>
    </Grid>
  );
};

export default IssuesCalendarDashboard;
